let tabindex = 1

const buildDefaultAttributes = (controlType, index) => {
  // tabindex is used to disable certain bootstrap styling which has 'not' selectors on tabindex
  return `${index !== undefined ? `data-index="${index}"` : ''} data-type="${controlType}" tabindex="${(tabindex =
    (tabindex + 1) % 10000)}"`
}

export default buildDefaultAttributes
